import { types } from 'mobx-state-tree';
import Modal from './Modal';

const CartModal = Modal.named('CartModal')
  .props({
    openedManually: types.optional(types.boolean, true),
  })
  .actions((self) => ({
    toggle: (wasOpenedManually = true) => {
      self.isOpen = !self.isOpen;

      // Only set the manual open state when the modal opens. If it is updated from
      // automatic -> manual during the close toggle, the manual UI will flash quickly
      // during the fade animation.
      if (self.isOpen) {
        self.openedManually = !!wasOpenedManually;
      }
    },
    close: () => {
      self.isOpen = false;
    },
  }));

export default CartModal;
